import type { GetTemplatesParams, SaveTemplatesModalInfo, SaveTemplatesParams } from '@/types/template';

import httpClient from '../utils/httpClient';

export default {
  async getTemplatesList(params: GetTemplatesParams) {
    const { data } = await httpClient.get('/api/emails/templates', {
      params
    });

    return data;
  },
  async saveTemplate(params: SaveTemplatesParams, modalInfo: SaveTemplatesModalInfo) {
    if (modalInfo.isEdit) {
      if (!modalInfo.uuid) return;
      await httpClient.put(`/api/emails/templates/${modalInfo.uuid}`, {
        ...params
      });
    } else {
      await httpClient.post('/api/emails/templates', {
        ...params
      });
    }
  },
  async getTemplateInfo(uuid: string) {
    const { data } = await httpClient.get(`/api/emails/templates/${uuid}`);

    return data;
  }
};
